import HubspotAttachments from '../collections/HubspotAttachments';
import { baseApi } from 'core/api';

const state = () => ({
    _type: null,
    _items: [],
    _pagination: null,
    _loading: false,
    _error: false,
    _parameters: {
        page: 1,
        after: 0,
        sortBy: null,
        sortOrder: null,
        search: null,
        limit: 5,
    },
    _pages: [0],
});

const getters = {
    hubspotAttachments: (state) => state._items,
    hubspotAttachmentsType: (state) => state._type,
    hubspotAttachmentsPagination: (state) => state._pagination,
    hubspotAttachmentsParameters: (state) => state._parameters,
    hubspotAttachmentsLoading: (state) => state._loading,
    hubspotAttachmentsError: (state) => state._error,
};

const utils = {
    parameters(state, getters) {
        const parameters = {
            ...state._parameters,
            after: state._pages[state._parameters.page - 1],
        };

        delete parameters.page;

        if (state._type === 'quotes') {
            const contactId = getters.conversation.contact.integration_vendor_id;

            return {
                ...parameters,
                limit: 999,
                contact_id: contactId,
            };
        }

        return parameters;
    },

    pages(state, nextPage) {
        const exist = state._pages.includes(nextPage);

        if (!exist) state._pages.push(nextPage);
    },
};

const actions = {
    // Snippets
    async setHubspotAttachmentsLoad() {
        if (this._loading) return;

        this._setHubspotAttachmentsLoading(true);

        return baseApi
            .get(`core/integrations/hubspot/${this._type}`, {
                params: utils.parameters.call(this, this, this),
            })
            .then((response) => {
                this._setHubspotAttachmentsLoaded(response.data);

                return response;
            })
            .catch(() => {
                this._setHubspotAttachmentsErrorLoading(true);
            })
            .finally(() => {
                this._setHubspotAttachmentsLoading(false);
            });
    },

    setHubspotAttachmentsReset() {
        this._setHubspotAttachmentsReset();
        this._setHubspotAttachmentsResetParameters();
    },

    setHubspotAttachmentsUpdatePage(page) {
        this._setHubspotAttachmentsUpdatePage(page);

        this.setHubspotAttachmentsLoad();
    },

    setHubspotAttachmentsUpdateSearch(search) {
        this._setHubspotAttachmentsUpdateSearch(search);

        this.setHubspotAttachmentsLoad();
    },

    setHubspotAttachmentsType(type) {
        this._setHubspotAttachmentsType(type);
    },

    setHubspotAttachmentsError(status) {
        this._setHubspotAttachmentsErrorLoading(status);
    },

    // Private methods
    _setHubspotAttachmentsLoaded(data) {
        this._items = new HubspotAttachments(data.data, { type: this._type }).models;

        const paging = data.paging || {
            next: {
                after: 0,
            },
        };
        const hasPaging = Boolean(data.paging);
        const per_page = this._parameters.limit;
        const current_page = this._parameters.page;
        const from = false;
        const to = false;
        const next_page_url = true;
        const last_page = current_page + 5;
        const total = hasPaging ? 100 : current_page * per_page;

        utils.pages(this, +paging.next.after);

        this._pagination = {
            current_page: current_page,
            from: from,
            last_page: last_page,
            per_page: per_page,
            to: to,
            total: total,
            next_page_url: next_page_url,
        };
    },

    _setHubspotAttachmentsReset() {
        this._items = [];
        this._pagination = null;
        this._loading = false;
        this._error = false;
        this._pages = [0];
    },

    _setHubspotAttachmentsResetParameters() {
        this._parameters = {
            page: 1,
            after: 0,
            sortBy: null,
            sortOrder: null,
            search: null,
            limit: 5,
        };
    },

    _setHubspotAttachmentsLoading(status) {
        this._loading = status;
    },

    _setHubspotAttachmentsUpdatePage(page) {
        this._parameters.page = page;
    },

    _setHubspotAttachmentsUpdateSearch(search) {
        this._parameters.search = search;
        this._parameters.after = 0;
    },

    _setHubspotAttachmentsType(value) {
        this._type = value;
    },

    _setHubspotAttachmentsErrorLoading(status = false) {
        this._error = status;
    },
};

export default {
    state,
    getters,
    actions,
};
